import React from "react";
import Editor from "@monaco-editor/react";

export default function CodeEditor({
  value,
  onChange,
  language = "json",
  height = "320px",
  readOnly = false,
}) {
  return (
    <div className="border border-zinc-200 rounded-md overflow-hidden bg-[#3730A3]">
      <Editor
        height={height}
        defaultLanguage={language}
        language={language}
        theme="vs-dark"
        value={value}
        onChange={(v) => onChange && onChange(v ?? "")}
        options={{
          minimap: { enabled: false },
          fontSize: 12,
          fontFamily: "JetBrains Mono, ui-monospace, monospace",
          scrollBeyondLastLine: false,
          tabSize: 2,
          wordWrap: "on",
          readOnly,
          padding: { top: 12, bottom: 12 },
        }}
      />
    </div>
  );
}
